import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 7.41667C8 7.62608 7.888 7.81917 7.706 7.923L5.66433 9.08967C5.57333 9.14158 5.47358 9.16667 5.37558 9.16667C5.17258 9.16667 4.976 9.06108 4.86867 8.87267C4.70883 8.59325 4.80625 8.23683 5.08567 8.077L6.83333 7.07833V4.5C6.83333 4.178 7.09408 3.91667 7.41667 3.91667C7.73925 3.91667 8 4.178 8 4.5V7.41667ZM15 10.9167V13.25C15 14.2148 14.2148 15 13.25 15H9.75C8.78517 15 8 14.2148 8 13.25V10.9167C8 10.1572 8.48942 9.5155 9.16667 9.274V8.58333C9.16667 8.26133 9.42742 8 9.75 8C10.0726 8 10.3333 8.26133 10.3333 8.58333V9.16667H12.6667V8.58333C12.6667 8.26133 12.9274 8 13.25 8C13.5726 8 13.8333 8.26133 13.8333 8.58333V9.274C14.5106 9.5155 15 10.1572 15 10.9167ZM13.8333 13.25V11.5H9.16667V13.25C9.16667 13.5714 9.428 13.8333 9.75 13.8333H13.25C13.572 13.8333 13.8333 13.5714 13.8333 13.25ZM6.36608 12.5617C3.93242 12.0676 2.16667 9.904 2.16667 7.41667C2.16667 4.52217 4.52158 2.16667 7.41667 2.16667C9.904 2.16667 12.0676 3.933 12.5611 6.36608C12.6252 6.68167 12.9321 6.887 13.2494 6.82167C13.565 6.7575 13.7692 6.4495 13.705 6.13392C13.1007 3.15892 10.4564 1 7.41667 1C3.87875 1 1 3.87875 1 7.41667C1 10.4564 3.15892 13.1012 6.13392 13.705C6.173 13.7132 6.21267 13.7167 6.25058 13.7167C6.52242 13.7167 6.76567 13.5259 6.82167 13.2494C6.88525 12.9338 6.68167 12.6258 6.36608 12.5617Z"
      fill="#151718"
    />
  </svg>
);

const ChangeShift = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default ChangeShift;
